import { useState, useEffect, useCallback } from 'react'
import FirmViewInvoices from 'src/components/portal/default/FirmViewComponents/FirmViewInvoices'
import {
  FirmDetailsInvoiceData,
} from 'src/dtos/portal'
import { api } from 'src/services/apiClient'
import { useAuth } from 'src/context/auth'
import Modal from 'react-modal'
import InvoiceCloudModalContent from 'src/components/portal/default/InvoiceCloudModalContent'

const Invoices = () => {
  const { user } = useAuth()
  const [firmDetailsInvoice, setFirmDetailsInvoice] = useState<FirmDetailsInvoiceData | undefined>(undefined)
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false)
  
  const fetchFirmInvoiceInfo = useCallback(async () => {
    if(user.firmId) {
      try {
        const { data } = await api.get(`/Firm/GetPolicyBilling/${user.firmId}`)

        setFirmDetailsInvoice(data)
      } catch(e) {
        setFirmDetailsInvoice({} as FirmDetailsInvoiceData)
      }
    } else {
      setFirmDetailsInvoice(undefined)
    }
  }, [user.firmId])

  useEffect(() => {
    fetchFirmInvoiceInfo()
  }, [fetchFirmInvoiceInfo])
  
  return (
    <div>
      <FirmViewInvoices invoiceData={firmDetailsInvoice} openInvoiceModal={() => setInvoiceModalOpen(true)} />
      <Modal
        isOpen={invoiceModalOpen}
        overlayClassName="react-modal-overlay"
        className="react-modal-content"
      >
        <InvoiceCloudModalContent
          close={() => setInvoiceModalOpen(false)}
        />
      </Modal>
    </div>
  )
}

export default Invoices